import { generator } from '@cms-max/cms-browser-api-client'
import { Activity, Component } from '@cms-max/medicare-api-sdk'
import { GeneratorArgs } from './generateEventMap'

export const mcfGenerator = generator(({ i18n }: GeneratorArgs) => {
  return ({
    // PDT Drawer: Open
    mcf_pdtdrawer_opendrawer: {
      core: {
        property: 'MAX',
        activity: Activity.OpenDrawer,
        component: Component.Mcf,
        elementId: 'mcf_pdtdrawer_opendrawer'
      }
    },
    // PDT Drawer: Close
    mcf_pdtdrawer_closedrawer: {
      core: {
        property: 'MAX',
        activity: Activity.CloseDrawer,
        component: Component.Mcf,
        elementId: 'mcf_pdtdrawer_closedrawer'
      }
    },
    // MNT Drawer: Open
    mcf_mntdrawer_opendrawer: {
      core: {
        property: 'MAX',
        activity: Activity.OpenDrawer,
        component: Component.Mcf,
        elementId: 'mcf_mntdrawer_opendrawer'
      }
    },
    // MNT Drawer: Close
    mcf_mntdrawer_closedrawer: {
      core: {
        property: 'MAX',
        activity: Activity.CloseDrawer,
        component: Component.Mcf,
        elementId: 'mcf_mntdrawer_closedrawer'
      }
    }
  }) // TODO: Uncomment - jest can't handle this right now. It likely needs updated to support: satisfies GenericEventMap
})

export type MCFKeys = keyof ReturnType<typeof mcfGenerator>

export default mcfGenerator
